import React, { useState } from 'react'
import Link from 'next/link'
import { useAnalytics } from 'clientHelpers/context/analyticsContext'
import { cx } from '@emotion/css'
import styles from './styles'

const Navigation = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false)

  const { addTrackingForCTA } = useAnalytics()

  const handleBodyScrolling = noScroll => {
    // The following is to prevent scrolling on the body when mobile nav is open
    if (noScroll) {
      document.body.classList.add(styles.noScroll)
    } else {
      document.body.classList.remove(styles.noScroll)
    }
  }

  const handleToggleMobileMenu = () => {
    handleBodyScrolling(!showMobileMenu)
    setShowMobileMenu(!showMobileMenu)
  }

  return (
    <>
      <nav className={`desktop-menu ${styles.standardNavigation}`}>
        <div className={`navigation-bar-items ${styles.navigationBarItems}`}>
          <Link href="https://offerzen.com">
            <img
              src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/logo.png`}
              alt="offerzen-logo"
              className={`offerzen-logo ${styles.offerzenLogoImage}`}
            />
          </Link>

          <div className={`nav-links-container ${styles.navigationLinksContainer}`}>
            <a
              {...addTrackingForCTA({
                action: 'Clicked Sign Up',
                sourceDetail: 'page nav',
                url: '/company/signup?marketplace_preview_lead=true',
              })}
              className={styles.filledNavButton}>
              Start hiring
            </a>
            <a className={styles.loginButton} href="/users/sign_in">
              Log in
              <img className={styles.arrowImage} src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/arrow.svg`} alt="arrow right" />
            </a>
          </div>

          <div className={styles.mobileNav}>
            <a className={styles.mobileMenuLink} onClick={handleToggleMobileMenu}>
              <img src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/burger_menu.svg`} alt="menu" className={styles.mobileMenuICon} />
            </a>
          </div>
        </div>
      </nav>
      <div className={`mobile-menu ${cx(styles.mobileNavigationMenuItems, showMobileMenu && styles.openMobileNavMenuItems)}`}>
        <a className={styles.filledNavButton} href="/company/signup?marketplace_preview_lead=true">
          Start hiring
        </a>
        <a className={styles.loginButton} href="/users/sign_in">
          Log in
          <img className={styles.arrowImage} src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/arrow.svg`} alt="arrow right" />
        </a>
        <div className={styles.closeMenuContainer} onClick={handleToggleMobileMenu}>
          <a className={styles.closeMenuNavButton} onClick={handleToggleMobileMenu}>
            Close menu
          </a>
        </div>
      </div>
    </>
  )
}

export default Navigation
